import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {NavController} from '@ionic/angular';
import {AuthApiService} from '../../Services/Api/Auth/auth-api.service';
import {RoutesEnum} from '../../Shared/Enum/routes.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly auth: AuthApiService,
    private readonly navCtrl: NavController,
  ) {
  }

  /**
   * Determina si una ruta puede activarse en función del estado de autenticación del usuario
   *
   */
  canActivate(): boolean {

    if (this.auth.userIsLogIn()) {
      return true;
    }

    this.navCtrl.navigateRoot(RoutesEnum.onboarding, {animated: false, animationDirection: 'forward'});
    return false;
  }

}
